import * as types from "./constant"

export const getUpSellStart = payload => ({
  type: types.GET_UPSELL_START,
  payload,
})

export const getUpSellSuccess = payload => ({
  type: types.GET_UPSELL_SUCCESS,
  payload,
})

export const getUpSellFailure = error => ({
  type: types.GET_UPSELL_FAILURE,
  payload: error,
})
export const getUpSellReset = () => ({
  type: types.GET_UPSELL_RESET,
})
